import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SelectProTypePageRoutingModule } from './select-pro-type-routing.module';

import { SelectProTypePage } from './select-pro-type.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SelectProTypePageRoutingModule
  ],
  declarations: [SelectProTypePage]
})
export class SelectProTypePageModule {}
